<template>
  <div class="verification-info">
    <h1 style="text-align: center; margin-top: 0px;">
      {{
        getVerification && getVerification.type.includes("landlord")
          ? "Residence"
          : "Employment"
      }}
      Verification for
      {{ getVerification.request_data.applicant_first_name }}
      {{ getVerification.request_data.applicant_last_name }}
    </h1>
    <div class="verification-info-container">
      <h2>
        Please complete the following
        {{
          getVerification.type.includes("landlord") ? "Residence" : "Employment"
        }}
        verification for {{ getApplicantFullName }}
      </h2>
      <div class="line"></div>

      <div v-if="getVerifyType.includes('landlord')">
        <div class="form-row">
          <div class="form-label" style="margin-right: 15px;">
            <h4>
              Verified By:
              <span
                v-if="requiredFields[getVerifyType].includes('verified_by')"
                class="required"
                >*</span
              >
            </h4>
          </div>
          <div
            class="form-input"
            :class="{ error: errors.includes('verified_by') }"
          >
            <input
              v-model="details.verified_by"
              type="text"
              placeholder="Your Name"
            />
          </div>
        </div>
        <h3>
          {{ getApplicantFullName }}'s
          {{ getVerifyType === "landlord" ? "Current" : "Past" }} Lease
          Information:
        </h3>
        <div class="line" style="height:2px;"></div>
        <div class="info-container">
          <div class="left-side">
            <div class="form-row">
              <div class="form-label">
                <h4>
                  Lease Start Date:
                  <span
                    v-if="
                      requiredFields[getVerifyType].includes('lease_start_date')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('lease_start_date') }"
              >
                <input
                  v-model="data.lease_start_date"
                  type="text"
                  placeholder="MM-DD-YYYY"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Lease End Date:
                  <span
                    v-if="
                      requiredFields[getVerifyType].includes('lease_end_date')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('lease_end_date') }"
              >
                <input
                  v-model="data.lease_end_date"
                  type="text"
                  placeholder="MM-DD-YYYY"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Move In Date:
                  <span
                    v-if="
                      requiredFields[getVerifyType].includes('move_in_date')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('move_in_date') }"
              >
                <input
                  v-model="data.move_in_date"
                  type="text"
                  placeholder="MM-DD-YYYY"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Move Out Date:
                  <span
                    v-if="
                      requiredFields[getVerifyType].includes('move_out_date')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('move_out_date') }"
              >
                <input
                  v-model="data.move_out_date"
                  type="text"
                  placeholder="MM-DD-YYYY"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Monthly Rent:
                  <span
                    v-if="
                      requiredFields[getVerifyType].includes(
                        'monthly_rent_amount'
                      )
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('monthly_rent_amount') }"
              >
                <input
                  v-model="data.monthly_rent_amount"
                  type="text"
                  placeholder="$1000"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Paid as Agreed:
                  <span
                    v-if="
                      requiredFields[getVerifyType].includes('pays_as_agreed')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('pays_as_agreed') }"
              >
                <input
                  v-model="data.pays_as_agreed"
                  type="text"
                  placeholder="Yes or No"
                />
              </div>
            </div>
          </div>
          <div class="right-side">
            <div class="form-row">
              <div class="form-label">
                <h4>
                  Late Payments:<span
                    v-if="
                      requiredFields[getVerifyType].includes('late_payments')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('late_payments') }"
              >
                <input
                  v-model="data.late_payments"
                  type="text"
                  placeholder="Late Payments"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  NSF Checks:<span
                    v-if="requiredFields[getVerifyType].includes('nsf_checks')"
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('nsf_checks') }"
              >
                <input
                  v-model="data.nsf_checks"
                  type="text"
                  placeholder="NSF Checks"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Balance Owed:<span
                    v-if="
                      requiredFields[getVerifyType].includes('balance_owed')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('balance_owed') }"
              >
                <input
                  v-model="data.balance_owed"
                  type="text"
                  placeholder="$0.00"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Legal Notices:<span
                    v-if="
                      requiredFields[getVerifyType].includes('legal_notices')
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('legal_notices') }"
              >
                <input
                  v-model="data.legal_notices"
                  type="text"
                  placeholder="Legal Notices"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Problems or Complaints:<span
                    v-if="
                      requiredFields[getVerifyType].includes(
                        'problems_complaints'
                      )
                    "
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('problems_complaints') }"
              >
                <input
                  v-model="data.problems_complaints"
                  type="text"
                  placeholder="Problems or Complaints"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-label">
                <h4>
                  Rent Again?<span
                    v-if="requiredFields[getVerifyType].includes('rent_again')"
                    class="required"
                    >*</span
                  >
                </h4>
              </div>
              <div
                class="form-input"
                :class="{ error: errors.includes('rent_again') }"
              >
                <input
                  v-model="data.rent_again"
                  type="text"
                  placeholder="Yes/No"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="getVerifyType === 'employment'">
        <div>
          <div class="form-row">
            <div class="form-label">
              <h4>
                Verified By:
                <span
                  v-if="requiredFields[getVerifyType].includes('verified_by')"
                  class="required"
                  >*</span
                >
              </h4>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('verified_by') }"
            >
              <input
                v-model="details.verified_by"
                type="text"
                placeholder="Your Name"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-label">
              <h4>
                Your Job Title
                <span
                  v-if="
                    requiredFields[getVerifyType].includes('verified_by_title')
                  "
                  class="required"
                  >*</span
                >
              </h4>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('verified_by_title') }"
            >
              <input
                v-model="details.verified_by_title"
                type="text"
                placeholder="CEO"
              />
            </div>
          </div>

          <h3>{{ getApplicantFullName }}'s Current Employment Information:</h3>
          <div class="line"></div>

          <div class="form-row">
            <div class="form-label">
              <h4>
                Employment Status:
                <span
                  v-if="
                    requiredFields[getVerifyType].includes('employment_status')
                  "
                  class="required"
                  >*</span
                >
              </h4>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('employment_status') }"
            >
              <input
                v-model="data.employment_status"
                type="text"
                placeholder="Currently or previously employed"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-label">
              <h4>
                Position/Title
                <span
                  v-if="
                    requiredFields[getVerifyType].includes('employment_title')
                  "
                  class="required"
                  >*</span
                >
              </h4>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('employment_title') }"
            >
              <input
                v-model="data.employment_title"
                type="text"
                placeholder="Employment title"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-label">
              <h4>
                Employment Start Date:
                <span
                  v-if="
                    requiredFields[getVerifyType].includes(
                      'employment_start_date'
                    )
                  "
                  class="required"
                  >*</span
                >
              </h4>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('employment_start_date') }"
            >
              <input
                v-model="data.employment_start_date"
                type="text"
                placeholder="MM-DD-YYYY"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-label">
              <h4 style="margin-bottom:0px;">
                Employment End Date:
                <span
                  v-if="
                    requiredFields[getVerifyType].includes(
                      'employment_end_date'
                    )
                  "
                  class="required"
                  >*</span
                >
              </h4>
              <p style="margin-top:0px;">(if previously employed)</p>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('employment_end_date') }"
            >
              <input
                v-model="data.employment_end_date"
                type="text"
                placeholder="MM-DD-YYYY"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-label">
              <h4>
                Employment Type:<span
                  v-if="
                    requiredFields[getVerifyType].includes('employment_type')
                  "
                  class="required"
                  >*</span
                >
              </h4>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('employment_type') }"
            >
              <input
                v-model="data.employment_type"
                type="text"
                placeholder="full-time, part-time, contractor, or other"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-label">
              <h4 style="margin-bottom:0px;">
                Reason for Leaving:<span
                  v-if="
                    requiredFields[getVerifyType].includes('reason_for_leaving')
                  "
                  class="required"
                  >*</span
                >
              </h4>
              <p style="margin-top:0px;">(if previously employed)</p>
            </div>
            <div
              class="form-input"
              :class="{ error: errors.includes('reason_for_leaving') }"
            >
              <input
                v-model="data.reason_for_leaving"
                type="text"
                placeholder="Reason For leaving"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="line"></div>
      <div class="button-container">
        <router-link
          tag="a"
          :to="{
            name: 'verify-section1',
            params: { verifyType: getVerifyType }
          }"
          >Back</router-link
        >
        <button :disabled="isLoading" @click="submit()">
          {{ isLoading ? "Submitting..." : "Submit" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";

import {
  VERIFICATION_SUCCESS,
  VERIFICATION_ERROR,
  VERIFICATION_REQUEST
} from "@/store/types";

const baseUrl = process.env.VUE_APP_BACKEND_HOST;

export default {
  data() {
    return {
      data: {},
      details: {},
      errors: [],
      requiredFields: {
        employment: [
          "verified_by",
          "verified_by_title",
          "employment_status",
          "employment_title",
          "employment_start_date",
          "employment_type"
        ],
        landlord: [
          "verified_by",
          "lease_start_date",
          "lease_end_date",
          "pays_as_agreed",
          "rent_again"
        ],
        previous_landlord: [
          "verified_by",
          "lease_start_date",
          "lease_end_date",
          "pays_as_agreed",
          "rent_again"
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      "getVerification",
      "isLoading",
      "getVerifyType",
      "getMethod"
    ]),
    getApplicantFullName() {
      if (this.getVerification)
        return `${this.getVerification.request_data.applicant_first_name} ${this.getVerification.request_data.applicant_last_name}`;
      return "";
    }
  },
  methods: {
    async submit() {
      this.errors = [];

      this.requiredFields[this.getVerifyType].map(field => {
        if (!this.data[field] && !this.details[field]) {
          this.errors.push(field);
        }
      });

      if (this.errors.length) {
        return;
      }

      try {
        this.$store.commit(VERIFICATION_REQUEST);

        const response = await axios.post(
          `${baseUrl}/api/verify/v1/verifications/add_attempt/`,
          {
            attempt: this.data,
            details: this.details,
            method: this.getMethod
          }
        );
        this.$store.commit(VERIFICATION_SUCCESS, {});
        this.$router.push({
          name: "verify-complete",
          params: { verifyType: this.getVerifyType }
        });
      } catch (err) {
        console.log(err);
        this.$store.commit(VERIFICATION_ERROR, err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.verification-info {
  background: #ebe9e9;
  padding: 40px 30px;
}
.verification-info-container {
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  padding: 30px;
  background-color: white;
  border-radius: 8px;
  box-sizing: border-box;
}
.required {
  color: red;
}
.form-input.error {
  input {
    border: 2px solid #ecacb4;
    background-color: #f8dade;
  }
}
.info-container {
  display: flex;
  flex-direction: horizontal;
}
.right-side {
  flex: 1;
  margin-left: 20px;
}
.form-row {
  display: flex;
  flex-direction: horizontal;
}
.form-label {
  flex: 1;
  margin-right: 15px;
}
.form-input {
  margin-top: 10px;
  margin-bottom: 10px;
  flex: 1;

  h4 {
    font-size: 16px;
    color: #545454;
    line-height: 1.1;
    margin: 0;
    text-align: left;
    display: inline-block;
    margin-right: 8px;
  }

  input {
    width: 300px;
    margin-top: 5px;
    border-radius: 2px;
    border: 2px solid #cfcfd2;
    font-size: 16px;
    color: #545454;
    padding: 9px;
    line-height: 1;
  }
}

.button-container {
  align-items: center;
  display: flex;
  justify-content: center;
  button {
    display: block;
    width: 150px;
    padding: 10px 0;
    border: 2px solid #3ec19d;
    background: #3ec19d;
    border-radius: 2px;
    text-decoration: none;
    font-size: 16px;
    color: #fff;
    text-align: center;
    font-weight: 600;
    cursor: pointer;
  }
  a {
    background: #fff;
    border-radius: 2px;
    border: 2px solid #b0b5bc;
    color: #768589;
    line-height: 1;
    display: block;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    width: 150px;
    float: left;
    padding: 8px 0;
    text-decoration: none;
    margin-right: 30px;
  }
}
@media (max-width: 768px) {
  .verification-info {
    padding: 40px 15px;
  }
  h1 {
    font-size: 28px;
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 16px;
  }
  .info-container {
    display: inline-block;
  }
  .right-side {
    margin-left: 0px;
  }
  .form-row {
    display: block;
    .form-label {
      h4 {
        margin-top: 5px;
        margin-bottom: 5px;
      }
      p {
        margin-bottom: 0px;
      }
    }
    .form-input {
      input {
        width: 95%;
      }
    }
  }
}
</style>
